import { Flex, Container } from "@chakra-ui/react";
import { Text } from "uikit";
import { SubscribeBox } from "./components/SubscribeBox";
import EmailIcon from "./components/EmailIcon";

export const SubscribeEmailView = () => {
  return (
    <Container maxW="1200px" pt={16} pb={24} height="100dvh">
      <Flex flexDir="column" px={{ base: "16px", md: "32px" }}>
        <EmailIcon boxSize="96px" alignSelf="flex-end" />
        <Text textStyle="display-01" bold color="text-01" mb={4}>
          Get the Alpha.
        </Text>
        <Text mb={8}>Sign up to our mailing list to get the latest updates on all things LooksRare.</Text>
        <SubscribeBox />
        <Text textStyle="detail" textColor="text-03">
          You can unsubscribe at any time via a link in any email we send to you.
        </Text>
      </Flex>
    </Container>
  );
};
